import React from 'react'
import { MainSlider } from '../../component/MainSlider'
import { LoungeCars } from '../../component/LoungeCars'
import { RequestBox } from '../../component/RequestBox'
import { SalesManagers } from '../../component/SalesManagers'
import { LastBlog } from '../../component/LastBlog'
import { WhyUs } from '../../component/WhyUs'
import { Benefits } from '../../component/Benefits'
import { Calculator } from '../../component/Calculator'
import { Contact } from '../../component/Contact'

export default function ContactPage() {
    return (
        <>
            <Contact />
        </>
    )
}
